import { QuizQuestion as QuizQuestionType, QuestionType } from '../../types/elearning';
import Input from '../ui/Input';

interface QuizQuestionProps {
  question: QuizQuestionType;
  value?: any;
  onChange: (answer: any) => void;
  showExplanation?: boolean;
  disabled?: boolean;
}

export default function QuizQuestionComponent({
  question,
  value,
  onChange,
  showExplanation = false,
  disabled = false,
}: QuizQuestionProps) {
  const handleMultipleChoiceChange = (optionText: string) => {
    onChange(optionText);
  };

  const handleTrueFalseChange = (answer: boolean) => {
    onChange(answer);
  };

  const handleShortAnswerChange = (answer: string) => {
    onChange(answer);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-start gap-2">
        <span className="font-semibold text-gray-900">{question.order}.</span>
        <div className="flex-1">
          <p className="font-semibold text-gray-900 mb-3">{question.question}</p>

          {question.type === QuestionType.MULTIPLE_CHOICE && (
            <div className="space-y-2">
              {question.options?.map((option, index) => (
                <label
                  key={index}
                  className="flex items-center gap-3 p-3 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors"
                >
                  <input
                    type="radio"
                    name={`question-${question.id}`}
                    value={option.text}
                    checked={value === option.text}
                    disabled={disabled}
                    onChange={() => handleMultipleChoiceChange(option.text)}
                    className="text-primary focus:ring-primary"
                  />
                  <span className="text-gray-700">{option.text}</span>
                </label>
              ))}
            </div>
          )}

          {question.type === QuestionType.TRUE_FALSE && (
            <div className="space-y-2">
              <label className="flex items-center gap-3 p-3 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                <input
                  type="radio"
                  name={`question-${question.id}`}
                  value="true"
                  checked={value === true}
                  disabled={disabled}
                  onChange={() => handleTrueFalseChange(true)}
                  className="text-primary focus:ring-primary"
                />
                <span className="text-gray-700">True</span>
              </label>
              <label className="flex items-center gap-3 p-3 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                <input
                  type="radio"
                  name={`question-${question.id}`}
                  value="false"
                  checked={value === false}
                  disabled={disabled}
                  onChange={() => handleTrueFalseChange(false)}
                  className="text-primary focus:ring-primary"
                />
                <span className="text-gray-700">False</span>
              </label>
            </div>
          )}

          {question.type === QuestionType.SHORT_ANSWER && (
            <Input
              type="text"
              value={value || ''}
              disabled={disabled}
              onChange={(e) => handleShortAnswerChange(e.target.value)}
              placeholder="Type your answer here"
              className="w-full"
            />
          )}

          {showExplanation && question.explanation && (
            <p className="text-sm text-gray-600 mt-3 italic">{question.explanation}</p>
          )}
        </div>
      </div>
    </div>
  );
}

